var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.element,_vm._g(_vm._b({tag:"component",staticClass:"base-display-text",class:_setup.baseDisplayTextClasses},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }